import React, {useState} from 'react';
import PropTypes from 'prop-types';
import useDidMountEffect from "../../../utils/useDidMountEffect";
import apiUser from "../../../apiUser";
import useAfterUpdateEffect from "../../../utils/useAfterUpdateEffect";
import Select from "../../../componentsReusable/Select";
import moment from "moment/moment";
import {isEmpty} from "lodash";
import {Table} from "reactstrap";
import {useTranslation} from "react-i18next";

const TypesSelect = props => {
  const { t } = useTranslation('tec_rmi');
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(false)

  useDidMountEffect(() => {
    if(props.rangeId){
      fetchData()
    }
  })

  useAfterUpdateEffect(() => {
    setData([])

    if(props.rangeId){
      fetchData()
    }
  }, [props.rangeId, props.showCar, props.showTruck, props.showBike])

  const fetchData = () => {
    setLoading(true)

    apiUser.tecRmi.vehicleTree.typeList({
      showCar: props.showCar,
      showTruck: props.showTruck,
      showBike: props.showBike,
      rangeId: props.rangeId,
    }).then(res => {
      setData(res.data)
    }).finally(() => {
      setLoading(false)
    })
  }

  const getOptions = () => {
    return data
      .filter(type => {
        if(props.typesIdFilter.length > 0 && !props.typesIdFilter.includes(type.TypeId)){
          return false
        }

        return true
      })
      .map(parseDataToOption)
  }

  const parseDataToOption = (data) => {
    const yearFrom = data.TypeDetails.find(td => td.AddInfoKeyId === 3)?.AddInfoKeyValue
    const yearTo = data.TypeDetails.find(td => td.AddInfoKeyId === 4)?.AddInfoKeyValue
    const power = data.TypeDetails.find(td => td.AddInfoKeyId === 5)
    const capacity = data.TypeDetails.find(td => td.AddInfoKeyId === 6)
    const engine = data.TypeDetails.find(td => td.AddInfoKeyId === 10)
    const type = data.TypeDetails.find(td => td.AddInfoKeyId === 7)
    const engineCodes = data.TypeDetails.filter(td => td.AddInfoKeyId === -4).map(typeDetail => typeDetail.AddInfoKeyValue)

    return {
      ...data,
      yearFrom,
      yearTo,
      power,
      capacity,
      engine,
      type,
      engineCodes,
    }

    return {
      _data: data,
      value: data.TypeId,
      label: <div className="d-flex flex-column">
        <span>
          <span>{data.TypeName}</span>
          <span className="ml-2 text-secondary">
            {yearFrom && <span>{moment(yearFrom).format('YYYY-MM')}</span>}
            <span className="px-1">do</span>
            {yearTo && <span>{moment(yearTo).format('YYYY-MM')}</span>}
          </span>
        </span>
        <small className="mt-1">
          <span className="mr-3">{t('capacity')}: <span className="text-secondary">{capacity?.AddInfoKeyValue} {capacity?.AddInfoKeyName}</span></span>
          <span className="mr-3">{t('power')}: <span className="text-secondary">{power?.AddInfoKeyValue} {power?.AddInfoKeyName}</span></span>
          <span className="mr-3">{t('fuel')}: <span className="text-secondary">{engine?.AddInfoKeyValue}</span></span>
          <span className="mr-3">{t('type')}: <span className="text-secondary">{type?.AddInfoKeyValue}</span></span>
          <span className="mr-3">{t('engine')}: <span className="text-secondary">{engineCodes.join(', ')}</span></span>
        </small>
      </div>,
    }
  }

  return <Table size={'sm'} className="table-hover table-bordered">
    <thead>
    <tr>
      <th>{t('types_select.table.column.name')}</th>
      <th>{t('types_select.table.column.year')}</th>
      <th>{t('types_select.table.column.power')}</th>
      <th>{t('types_select.table.column.engine_codes')}</th>
      <th>{t('types_select.table.column.capacity')}</th>
      <th>{t('types_select.table.column.engine')}</th>
      <th>{t('types_select.table.column.type')}</th>
    </tr>
    </thead>
    <tbody>
    {loading && <tr>
      <td colSpan={7} className="text-center"><i className="fas fa-spinner fa-spin" /></td>
    </tr>}
    {getOptions().map((data, key) => <tr key={key} className="cursor-pointer" onClick={() => props.onChange(data.TypeId)}>
      <td>{data.TypeName}</td>
      <td>
        {data.yearFrom && <span>{moment(data.yearFrom).format('YYYY-MM')}</span>}
        <span className="px-1">-</span>
        {data.yearTo && <span>{moment(data.yearTo).format('YYYY-MM')}</span>}
      </td>
      <td>{data.power?.AddInfoKeyValue} {data.power?.AddInfoKeyName}</td>
      <td>{data.engineCodes.join(', ')}</td>
      <td>{data.capacity?.AddInfoKeyValue} {data.capacity?.AddInfoKeyName}</td>
      <td>{data.engine?.AddInfoKeyValue}</td>
      <td>{data.type?.AddInfoKeyValue}</td>
    </tr>)}
    </tbody>
  </Table>

  return <Select
    autoFocus={!!props.rangeId}
    placeholder={t('select_placeholder')}
    filterOption={(candidate, input) => {
      if(isEmpty(input)){
        return true
      }

      let searchableValues = candidate.data._data.TypeDetails.map(typeDetail => typeDetail.AddInfoKeyValue)
      searchableValues.push(candidate.data._data.TypeName)

      searchableValues = searchableValues.join(' ').toLowerCase()

      return input.split(' ').filter(text => searchableValues.toLowerCase().includes(text.toLowerCase())).length > 0
    }}
    isLoading={loading}
    isDisabled={!props.rangeId}
    options={getOptions()}
    onChange={props.onChange}
    value={props.value}
  />};

TypesSelect.propTypes = {
  typesIdFilter: PropTypes.array,
  rangeId: PropTypes.number,
  value: PropTypes.number,
  onChange: PropTypes.func.isRequired,
};

export default TypesSelect;